/**
 * User Reducers
 */


const PortfolioItems = [
  {
			'name': 'The Church Co',
			'image': '/assets/thechurchco.jpg',
			'description': 'A web platform that provides cost affordable, high quality, websites for churches and ministries.',
			'link': 'http://thechurchco.com',
			'feature': '/assets/portfolio/thechurchco.png',
      'slug': 'thechurchco'
		},
		{
			'name': 'Hillsong',
			'image': '/assets/hillsong.jpg',
			'description': 'In 2012 we embarked on redesigning hillsong.com to combined all sites into a single domain. The project took about three years from design to dev complete. It is continually expanding and evolving.',
			'link':'http://hillsong.com',
			'feature': '/assets/portfolio/hillsong.png',
      'slug': 'hillsong'
		},
		{
			'name': 'Amnesty International Australia',
			'image': '/assets/amnesty.jpg',
			'description': "A product of <a href=\"http://agency.sc\" target=\"_blank\">Agency</a>, this website is by far the largest I've ever built. This is site is built on Wordpress with a custom theme and plugin development powering deep and custom integrations. Content is served based on user profiles that are based on your site interations to give you the content that is most relevant to you.",
			'link':'http://amnesty.org.au',
			'feature': '/assets/portfolio/amnesty.png',
      'slug': 'amnesty'
		},
		{
			'name': 'Baptist World Aid',
			'image': '/assets/bwa.jpg',
			'description': "A product of <a href=\"http://agency.sc\" target=\"_blank\">Agency</a>. One of my favourite sites. This is a custom Wordpress site that extends WooCommerce to handle all sorts to new features... Child Sponsorship, Recurring Giving, Sending eCards and managing customer relations.",
			'link':'http://baptistworldaid.org.au',
			'feature': '/assets/portfolio/bwa.png',
      'slug': 'baptist-world-aid'
		},
		{
			'name': 'The Australian Literacy & Numeracy Foundation',
			'image': '/assets/alnf.jpg',
			'description': "A product of <a href=\"http://agency.sc\" target=\"_blank\">Agency</a>, The Australian Literacy and Numeracy Foundation (ALNF) is dedicated to raising language, literacy and numeracy standards in Australia and raises funds to develop, implement and sustain innovative projects for individuals, families and communities.",
			'link':'http://alnf.org',
			'feature': '/assets/portfolio/alnf.png',
      'slug': 'alnf'
		},
		{
			'name': 'Victorian Nation Park Association',
			'image': '/assets/vnpa.jpg',
			'description': "A product of <a href=\"http://agency.sc\" target=\"_blank\">Agency</a>, VNPA is for the protection of the National Parks in Victoria, Australia. Their site is built on Wordpress and has advanced custom feature for making donations, becoming a member, and integrating with their CRM.",
			'link':'https://vnpa.org.au/',
			'feature': '/assets/portfolio/vnpa.png',
      'slug': 'vnpa'
		},


]

const initialState = {
  items: PortfolioItems
}


export default (state = initialState, action) => {
    switch (action.type) {
        case 'GET_PORTFOLIO':

             return Object.assign({}, state, {
                 items: action.items

             })
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/Reducers/Portfolio.js